module.exports = __webpack_public_path__ + "img/guardian.d6826163.svg";